module.exports = __webpack_public_path__ + "static/media/spring2.dae64eee.jpeg";